import { useStaticIntl } from '@tribeplatform/react-components/i18n'
import { useBlock } from '@tribeplatform/react-slate-kit/hooks'
import type { BC } from '@tribeplatform/react-slate-kit/types'

import { MultiViewBlock } from '../Views/components/MultiViewBlock'
import { convertToStatic } from '../Views/utils'
import { GenericQuickLinks } from './components/GenericQuickLinks'
import { genericViewFactory, staticFieldsFactory } from './config'
import type { QuickLinksBlockProps } from './types'

export const QuickLinksBlock: BC<QuickLinksBlockProps> = ({
  title,
  description,
  linkText,
  linkUrl,
  views,
}) => {
  const genericView = useStaticIntl(genericViewFactory)
  const staticFields = useStaticIntl(staticFieldsFactory)
  const {
    extraContext: { activeViewIndex, activeFieldId },
  } = useBlock<
    QuickLinksBlockProps,
    { activeViewIndex?: number; activeFieldId?: string }
  >()

  return (
    <MultiViewBlock
      activeViewIndex={activeViewIndex}
      title={title}
      description={description}
      views={views}
      linkUrl={linkUrl}
      linkText={linkText}
    >
      {({ view, preview }) => (
        <>
          {view && (
            <GenericQuickLinks
              style={view.style}
              sources={view.sources}
              fields={convertToStatic(view.fields, staticFields, [])}
              gallerySize={view.gallerySize}
              showDivider={view.showDivider}
              activeFieldId={activeFieldId}
              preview={preview}
            />
          )}
          {!view && (
            <GenericQuickLinks
              style={genericView.style}
              sources={genericView.sources}
              fields={convertToStatic(staticFields, staticFields, [])}
              gallerySize={genericView.gallerySize}
              showDivider={genericView.showDivider}
              activeFieldId={activeFieldId}
              preview={preview}
            />
          )}
        </>
      )}
    </MultiViewBlock>
  )
}
